<template>
  <div class="examInfo-card">
    <div class="left">
      <div class="img-box">
        <img :src="content.picture_url">
      </div>
      <div class="info-box">
        <div class="text-header">
          <div class="tags">
          </div>
          <!-- <span class="subject-type">统考科目</span> -->
          <span class="subject-name">{{content.name}}</span>
        </div>
        <p class="title">{{content.description}}</p>
        <p class="old-price">¥{{content.market_price}}</p>
        <div class="text-footer">
          <span class="new-price">¥{{content.price}}</span>
        </div>
      </div>
      <!-- <div class="text-box">
        注意：此题库仅适用于  内蒙古大学 汉语文学专业
      </div> -->
    </div>
    <div class="right">
      <div class="button-wrap">
        <router-link :to="`/exam/edit/${content.id}`">
          <el-button type="primary">编辑基本信息</el-button>
        </router-link>
      </div>
      <div class="text-wrap">
        <div class="exam-num">
          <p>{{content.item_count || 0}}</p>
          <span>总题数</span>
        </div>
        <div class="member-num">
          <p>{{content.user_count || 0}}位</p>
          <span>研友在学</span>
        </div>
        <div>
          <p>100道</p>
          <span>研友收藏题目</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.examInfo-card {
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 20px;
  overflow: hidden;

  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    flex: 1;

    .img-box {
      margin-right: 15px;
    }
    img {
      width: 94px;
      height: 94px;
      object-fit: cover;
    }
    .text-box {
      width: 100%;
      margin-top: 10px;
    }
    .text-header {
      display: flex;
      margin-bottom: 10px;
    }
    .tag {
      font-size: 12px;
      color: #fff;
      background: #0091ff;
      border-radius: 5px;
      padding: 2px 5px;
      margin-right: 10px;
    }
    .subject-type {
      font-weight: bold;
      margin-right: 10px;
    }
    .subject-name {
      font-size: 18px;
      font-weight: bold;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 400px;
    }
    .old-price {
      font-weight: bold;
      color: #999;
      text-decoration: line-through;
    }
    .new-price {
      font-weight: bold;
      color: #ff6600;
    }
    .member-price {
      font-size: 12px;
      color: #fff;
      padding: 2px 10px;
      background: #0091ff;
      border-radius: 5px;
      margin-left: 5px;
    }
    .text-footer {
      margin-top: 5px;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 1;

    .button-wrap {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    .text-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      & > div {
        text-align: center;
        padding: 0 30px;
      }
    }

    .member-num {
      border: 1px solid #ccc;
      border-width: 0 1px;
    }

    p {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}
</style>
